import { useTranslation } from 'react-i18next';

export const useLocalizedDate = () => {
  const { i18n } = useTranslation();

  const formatDate = (date, options = {}) => {
    const defaultOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      ...options
    };

    try {
      const dateObj = date instanceof Date ? date : new Date(date);
      return new Intl.DateTimeFormat(i18n.language, defaultOptions).format(dateObj);
    } catch (error) {
      console.error('Ошибка при форматировании даты:', error);
      return String(date);
    }
  };

  return formatDate;
};





